import axios from "axios";
import { getAuthHeaders } from "./auth";

const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:7071/api";

/**
 * Response shape from GET /api/manage/users/lookup?upn=...
 *
 * Backend returns 200 in two distinct cases:
 *   - `{ exists: true, displayName, accountEnabled, jobTitle, slackId }`  → user found
 *   - `{ exists: false }`                                                 → user not found
 *
 * Errors (malformed UPN, Graph 5xx, etc.) come back as 4xx/5xx HTTP, which
 * axios surfaces as thrown errors — callers should catch and surface the
 * server message.
 */
export interface UserLookupResult {
  exists: boolean;
  displayName?: string;
  accountEnabled?: boolean;
  jobTitle?: string | null;
  slackId?: string | null;
}

export async function lookupUser(upn: string): Promise<UserLookupResult> {
  const resp = await axios.get(
    `${BASE_URL}/manage/users/lookup?upn=${encodeURIComponent(upn)}`,
    { headers: getAuthHeaders() }
  );
  return resp.data as UserLookupResult;
}
